// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FinancialScreeningResultSearchResponse } from './financialScreeningResultSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class FinancialScreeningV1FinancialScreeningV1FinancialScreeningResultSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': FinancialScreeningResultSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof FinancialScreeningV1FinancialScreeningV1FinancialScreeningResultSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "FinancialScreeningResultSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return FinancialScreeningV1FinancialScreeningV1FinancialScreeningResultSearchDefaultResponse.attributeTypeMap;
    }
}
